import React from 'react';
import styles from "./footer.module.sass"
import line from "../../assets/White__line.png"

export const Footer = () => {
    return (
        <div className={styles.section__footer__wrap}>
            <div className={styles.section__footer}>
                <div className={styles.section__footer__column1}>
                    <div>
                        <a id='footerTg' href="https://t.me/vashe_velichie_kazan" target='_blank'>
                            <span className={styles.section__footer__text}>Телеграм</span>
                        </a>
                    </div>
                    <div>
                        <a href="https://vk.com/vashevelichie_ru" target='_blank'>
                            <span className={styles.section__footer__text}>ВКонтакте</span>
                        </a>
                    </div>
                    <div>
                        <a href="https://ok.ru/vashevelichie" target='_blank'>
                            <span className={styles.section__footer__text}>Одноклассники</span>
                        </a>
                    </div>
                    <div>
                        <span className={styles.section__footer__textDisabled}>bigwork02@mail.ru</span>
                    </div>
                    <div>
                        <span id='footerPhone' className={styles.section__footer__textDisabled}>+7 (987) 254-88-54</span>
                    </div>
                </div>
                <div className={styles.section__footer__column1Hidden}>
                   <div className={styles.section__footer__hiddenRow1}>
                       <div>
                           <a id='footerTg' href="https://t.me/vashe_velichie_kazan" target='_blank'>
                               <span className={styles.section__footer__text}>Телеграм</span>
                           </a>
                       </div>
                       <div>
                           <a href="https://vk.com/vashevelichie_ru" target='_blank'>
                               <span className={styles.section__footer__text}>ВКонтакте</span>
                           </a>
                       </div>
                       <div>
                           <a href="https://ok.ru/vashevelichie" target='_blank'>
                               <span className={styles.section__footer__text}>Одноклассники</span>
                           </a>
                       </div>
                   </div>
                    <img className={styles.line} src={line} alt=""/>
                    <div className={styles.section__footer__hiddenRow2}>
                        <div>
                            <span
                                className={styles.section__footer__textDisabled}>bigwork02@mail.ru
                            </span>
                        </div>
                        <div>
                            <a id='footerPhone' className={styles.section__footer__text} href="tel:+79872548854">+7 (987) 254-88-54</a>
                        </div>
                    </div>
                </div>
                <img className={styles.line} src={line} alt=""/>
                <div className={styles.section__footer__column2}>
                    <span  className={styles.section__footer__text2}>Ваше Величие 2023 ©️</span>
                </div>
            </div>
        </div>
    );
};